// src/components/ScanScorePromo.js

import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, ArrowRight, Zap } from 'lucide-react';
import '../styles/ScanScorePromo.scss';

const ScanScorePromo = () => {
  return (
    <section className="scanscore-promo" aria-label="ScanScore Assessment Partner">
      <div className="scanscore-promo__container">
        <div className="scanscore-promo__panel">
          <div className="scanscore-promo__content">
            <span className="scanscore-promo__eyebrow">
              <Zap size={14} /> Smart Assessment & Evaluation Partner
            </span>
            <h3 className="scanscore-promo__title">
              Exam Checking & Instant Grading Powered by{' '}
              <a 
                href="https://scanscore.app" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                ScanScore (scanscore.app)
              </a>
            </h3>
            <p className="scanscore-promo__text">
              Transforming test evaluation with instant phone-based OMR scanning on plain A4 paper. Eliminates manual red-pen checking, reduces grading time by 95%, and provides real-time diagnostic performance insights for teachers and students.
            </p>
          </div>
          <div className="scanscore-promo__actions">
            <a 
              href="https://scanscore.app" 
              target="_blank" 
              rel="noopener noreferrer"
              className="scanscore-promo__link-primary"
              title="Visit official ScanScore website (scanscore.app)"
            >
              Visit scanscore.app <ExternalLink size={15} />
            </a>
            <Link 
              to="/scanscore-assessment" 
              className="scanscore-promo__link-secondary"
              title="Read how ScanScore eases teacher workload and enhances school exams"
            >
              How It Eases Work <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScanScorePromo;

